import React, { useState } from 'react';
import './style.scss';

const CustomSelect = ({ options, onChange, defaultValue, Icon }) => {
	const [selectedValue, setSelectedValue] = useState('');

	const handleChange = (e) => {
		setSelectedValue(e.target.value);
		onChange(e);
	};

	return (
		<div className='custom-select'>
			<select onChange={handleChange} value={selectedValue}>
				<option value='' disabled hidden>
					{defaultValue}
				</option>
				{options.map((item, index) => (
					<option
						style={{
							fontSize: item.fontSize ? item.fontSize : '13px',
						}}
						key={index}
						value={item.value}
					>
						{item.label}
					</option>
				))}
			</select>
			{Icon && <Icon />}
		</div>
	);
};

export default CustomSelect;
